import { APP_USER_TYPE, TID } from '$services/api'
import { create } from 'zustand'

export type Profile = {
  id: TID
  name: string
  email: string
  phone_code: string
  phone_no: string
  is_verified?: boolean
  status: 'active' | 'inactive'
  user_type: APP_USER_TYPE
  created_at: string
  last_login_at: string
  gender: string
  date_of_birth: string
  address: string
  password_updated_at: string
  location: string
  ip_address: string
  timezone: string
  type?: string
  role?: string
  is_phone_verified?: boolean
  email_verified_at?: string | null
}

interface IProfileDataState {
  profile?: Profile
  updateProfile: (profile: IProfileDataState['profile']) => void
  updateProfilePartially: (data: Partial<IProfileDataState['profile']>) => void
}

export const useProfileDataStore = create<IProfileDataState>()(set => ({
  profile: undefined,
  updateProfile: profile => set({ profile }),
  updateProfilePartially: data =>
    set(state => ({
      profile: state.profile ? { ...state.profile, ...data } : undefined
    }))
}))
